import UserMenuButton from '@shared/components/user/UserMenuButton';
import { useTranslation } from 'react-i18next';
import { SvgFullLogo } from '../images/icons/brand';
import SrOnlyText from '../text/SrOnlyText';
import { ButtonContainer, HeaderContainer, HomeLink } from './CommonHeaderStyles';

// TODO ADMIN: Move this to the new 'Admin' folder see Issue #1354
// TODO ADMIN: Update settingsHref to the correct path after routing is established see Issue #1354
// TODO ADMIN: Update home link discuss if should go back to the dashboard or the main page see Issue #1354

export default function WebHeader() {
    const { t } = useTranslation();
    return (
        <HeaderContainer>
            <HomeLink href="#/">
                <SvgFullLogo width={125} />
                <SrOnlyText>{t('common:home.title')}</SrOnlyText>
            </HomeLink>
            <ButtonContainer>
                <UserMenuButton settingsHref={'../my-account'} notificationHref={'../notifications'} />
            </ButtonContainer>
        </HeaderContainer>
    );
}
